<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="版本号：" prop="version">
                <span>{{model.version}}</span>
            </el-form-item>
            <el-form-item label="是否强制：" prop="is_force">
                <span>{{ transEnu(model.is_force, "yesNo")}}</span>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <span>{{model.remark}}</span>
            </el-form-item>
            <el-form-item label="发布时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'appVersionAppleInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                version: '',
                url: '',
                is_force: '',
                remark: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/appversionapple/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['yesNo'],
        };
    },
    methods: {}
};
</script>